<template>
  <a
    v-if="shouldShowCta"
    class="cta"
    :style="ctaButtonElStyles"
    target="_self"
    :href="effectiveHref"
    @click="
      $emit('emittedClick', {
        type: 'cta',
        el: ctaButton,
      })
    "
  >
    <span>{{ ctaButton.text }}</span>
  </a>
</template>

<script>
export default {
  name: "NavigationCta",
  props: {
    ctaButton: {
      type: Object,
      required: true,
    },
    ctaButtonElStyles: {
      type: Object,
      default: () => ({}),
    },
    href: {
      type: String,
      default: null,
    },
  },
  emits: ["emittedClick"],
  computed: {
    shouldShowCta() {
      return this.effectiveHref !== "https://www.example.com";
    },
    effectiveHref() {
      return this.href || this.ctaButton.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.cta {
  @include font-family("button");
  font-weight: var(--cr-button-font-weight);

  display: flex;
  align-items: center;
  justify-content: center;

  min-width: fit-content;
  height: 32px;
  padding: 0 16px;

  color: var(--cr-navigation-cta-color);
  text-decoration: none;

  background-color: var(--cr-navigation-cta-background-color);
  border: var(--cr-navigation-cta-border);

  cursor: pointer;
  transition: all ease-in-out 200ms;

  @include tablet {
    display: none;

    .bottom-links & {
      display: inherit;
    }
  }

  span {
    text-align: center;
  }
}

.cta:hover {
  background-color: var(--cr-navigation-hover-color);
  border-color: var(--cr-navigation-hover-color);
}
</style>
